import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchExpiryReturnConfigs,
  fetchExpiryReturnConfigById,
  addExpiryReturnConfig,
  updateExpiryReturnConfig,
  removeExpiryReturnConfig,
} from "../../api/expiryReturnConfigApi";

export const getExpiryReturnConfigs = createAsyncThunk(
  "expiryReturnConfig/getExpiryReturnConfigs",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await fetchExpiryReturnConfigs();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getExpiryReturnConfigById = createAsyncThunk(
  "expiryReturnConfig/getExpiryReturnConfigById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await fetchExpiryReturnConfigById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createExpiryReturnConfig = createAsyncThunk(
  "expiryReturnConfig/createExpiryReturnConfig",
  async (data: any, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await addExpiryReturnConfig(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editExpiryReturnConfig = createAsyncThunk(
  "expiryReturnConfig/editExpiryReturnConfig",
  async (
    { id, data }: { id: string; data: any },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());
    try {
      return await updateExpiryReturnConfig(id, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteExpiryReturnConfig = createAsyncThunk(
  "expiryReturnConfig/deleteExpiryReturnConfig",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await removeExpiryReturnConfig(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const expiryReturnConfigSlice = createSlice({
  name: "expiryReturnConfig",
  initialState: {
    configs: [] as any[],
    config: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getExpiryReturnConfigs.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.configs = action.payload?.data || [];
        }
      )
      .addCase(getExpiryReturnConfigs.rejected, (state, action) => {
        state.status = false;
        state.configs = [];
        state.error = action.payload as string;
      })
      .addCase(
        getExpiryReturnConfigById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.config = action.payload?.data;
        }
      )
      .addCase(getExpiryReturnConfigById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(createExpiryReturnConfig.fulfilled, (state) => {
        state.status = true;
        state.msg = "Expiry Return Configuration created successfully.";
      })
      .addCase(createExpiryReturnConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(editExpiryReturnConfig.fulfilled, (state) => {
        state.status = true;
        state.msg = "Expiry Return Configuration updated successfully.";
      })
      .addCase(editExpiryReturnConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(deleteExpiryReturnConfig.fulfilled, (state) => {
        state.status = true;
        state.msg = "Expiry Return Configuration deleted successfully.";
      })
      .addCase(deleteExpiryReturnConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = expiryReturnConfigSlice.actions;
export default expiryReturnConfigSlice.reducer;
